import { render, staticRenderFns } from "./CustomerOrderItemChangeRequestPopUp.vue?vue&type=template&id=0b2706cd&scoped=true&"
import script from "./CustomerOrderItemChangeRequestPopUp.vue?vue&type=script&lang=js&"
export * from "./CustomerOrderItemChangeRequestPopUp.vue?vue&type=script&lang=js&"
import style0 from "./CustomerOrderItemChangeRequestPopUp.vue?vue&type=style&index=0&id=0b2706cd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b2706cd",
  null
  
)

export default component.exports